// extracted by mini-css-extract-plugin
export var body = "_k5-0";
export var sectionHeader = "_k5-4";
export var shortcutColumns = "_k5-2";
export var shortcutList = "_k5-1";
export var shortcutSection = "_k5-3";